import clsx from 'clsx';

export default function OpenCloseMenuButton({
  open = false,
  onClick,
  className,
  size = 'md',
  variant = 'default',
  ...props
}) {
  const sizeClass = size === 'sm' ? 'h-8 w-8' : 'h-9 w-9';

  return (
    <button
      type="button"
      className={clsx(
        'group inline-flex shrink-0 items-center justify-center rounded-lg border text-control transition hover:text-link',
        variant === 'default' &&
          'border-control bg-control shadow-resting hover:border-control-hover',
        variant === 'ghost' &&
          'border-transparent bg-transparent shadow-none hover:border-control hover:bg-control-hover',
        sizeClass,
        className
      )}
      onClick={onClick}
      aria-expanded={open}
      aria-label={open ? 'Chiudi menu' : 'Apri menu'}
      {...props}
    >
      <svg
        className="pointer-events-none"
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4 12L20 12"
          className="origin-center translate-y-[-7px] transition-all duration-300 [transition-timing-function:cubic-bezier(.5,.85,.25,1.1)] group-aria-expanded:translate-x-0 group-aria-expanded:translate-y-0 group-aria-expanded:rotate-315"
        />
        <path
          d="M4 12H20"
          className="origin-center transition-all duration-300 [transition-timing-function:cubic-bezier(.5,.85,.25,1.8)] group-aria-expanded:rotate-45"
        />
        <path
          d="M4 12H20"
          className="origin-center translate-y-[7px] transition-all duration-300 [transition-timing-function:cubic-bezier(.5,.85,.25,1.1)] group-aria-expanded:translate-y-0 group-aria-expanded:rotate-135"
        />
      </svg>
    </button>
  );
}
